<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" CustomPageActions  v-if="user.role == 'master'">
          <v-card class="px-3" :loading="loading">
            <v-row class="pa-0">
              <v-col cols="12" md="6">
                <v-btn block text color="success" :loading="loading"  @click="addNumber()"
                  :class="`${arabic?'arFont':'enFont'}`"
                >Add Number</v-btn>
              </v-col>
              <v-col cols="12" v-if="false">
                <v-expansion-panels focusable>
                  <v-expansion-panel style="cursor:pointer;">
                  <v-expansion-panel-header>
                    <span style="font-size:12px;">STATS</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <line-chart :height="200" ref="chart" :chartdata="data" :options="options"/>
                  </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
            <v-row row justify-center>
              <v-dialog v-model="newDialog" persistent max-width="1000">
                <v-card>
                  <v-card-title class="headline">Q</v-card-title>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" md="12" class="py-1">
                        
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" text @click.native="newDialog = false">cancel</v-btn>
                    <v-btn color="success" text @click.native="">verify</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </v-card>
        </v-col>
        
        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row class="pa-0 mb-2 elevation-2 px-2 align-center py-3 text-center"  v-for="(s, i) in settings" :key="'resource-'+i">
                <v-col cols="12" class="pa-0">
                  <v-card flat>
                    <v-row class="align-center">
                      <v-col cols="3" class="py-1" v-if="false">
                        <v-switch label="Official API" :disabled="loading"  v-model="s.official" :value="true"></v-switch>
                      </v-col>
                      <v-col cols="3" class="py-1">
                        <v-select
                          label="Country"
                          v-model="s.country"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :items="countries"
                          :disabled="loading || (user.role != 'master' && user.role != 'superadmin')"
                          hide-details
                          
                        ></v-select>
                      </v-col>
                      <v-col cols="3" class="py-1">
                        <v-text-field
                          label="Number"
                          v-model="s.number"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :disabled="loading || (user.role != 'master' && user.role != 'superadmin')"
                          hide-details
                          
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="s.official">
                        <v-text-field
                          label="ADMIN"
                          v-model="s.admin"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :disabled="loading"
                          hide-details
                          
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="s.official">
                        <v-text-field
                          label="PASSWORD"
                          v-model="s.password"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :disabled="loading"
                          hide-details
                          
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master'">
                        <v-text-field
                          label="Instance ID"
                          v-model="s.id"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          disabled
                          readonly
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' || user.role == 'superadmin'">
                        <v-text-field
                          label="Instance URL"
                          v-model="s.instance"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :disabled="loading"
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="!s.official && user.role == 'master'">
                        <v-text-field
                          label="Instance Token"
                          v-model="s.token"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          disabled
                          readonly
                          hide-details
                          
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master'">
                        <v-text-field
                          label="Instance Secret"
                          v-model="s.secret"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :disabled="loading"
                          hide-details
                          
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' || user.role == 'superadmin'">
                        <v-text-field
                          label="Notification Email"
                          v-model="s.email"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :disabled="loading"
                          hide-details
                          
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' || user.role == 'superadmin'">
                        <v-select
                          label="Instance State"
                          v-model="s.state"
                          :items="['old', 'new']"
                          outlined dense
                          :class="`${arabic?'arFont':'enFont'}`"
                          :disabled="loading"
                          hide-details
                          
                        ></v-select>
                      </v-col>
                      <v-col cols="3" :class="`${arabic?'arFont':'enFont'} py-1`" v-if="user.role != 'master' && false">
                        PAID TILL: {{getFormat(s.paidTill)}}
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="false">
                        <v-avatar
                          size="12"
                          class="mx-2"
                          v-if="s.id"
                          :color="!s.stopped ? 'green' : 'red'"
                        >
                          <v-icon size="10" color="white" v-if="!s.stopped">done</v-icon>
                          <v-icon size="10" color="white" v-else>close</v-icon>
                        </v-avatar>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' && false">
                        <v-btn color="primary" @click="setupInstance(s)" text :loading="loading" :disabled="loading" :class="`${arabic?'arFont':'enFont'}`">setup Instance</v-btn>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' && false">
                        <v-btn color="primary" @click="setupProfile(s)" text :loading="loading" :disabled="loading" :class="`${arabic?'arFont':'enFont'}`">setup Profile</v-btn>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' && false">
                        <v-btn color="primary" @click="checkStatus(s)" text :loading="loading" :disabled="loading" :class="`${arabic?'arFont':'enFont'}`">check status</v-btn>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' && false">
                        <v-btn color="primary" @click="useHere(s)" text :loading="loading" :disabled="loading" :class="`${arabic?'arFont':'enFont'}`">use WA here</v-btn>
                      </v-col>
                      <v-col cols="3" class="py-1" v-if="user.role == 'master' && false">
                        <v-btn color="error" @click="deleteInstance(s)" text :loading="loading" :disabled="loading" :class="`${arabic?'arFont':'enFont'}`">Delete instance</v-btn>
                      </v-col>
                      <v-col cols="3" class="py-1">
                        COUNT: {{s.count}}
                      </v-col>
                      <v-dialog v-model="qr" persistent max-width="600">
                        <v-card>
                          <v-card-title class="headline">Please Scan QR</v-card-title>
                          <v-card-text class="text-xs-center">
                            <v-row row wrap>
                              <v-col xs12>
                                <img :src="qrCode">
                              </v-col>
                              <v-col xs12>
                                <v-btn outline color="primary" @click="checkStatus(s)" dark>Scan Then Click here</v-btn>
                              </v-col>
                            </v-row>
                          </v-card-text>
                          <v-card-actions>
                            <v-progress-circular indeterminate v-if="loading" color="primary"></v-progress-circular>
                            <v-spacer></v-spacer>
                            <v-btn outline color="error" @click="qr = false">{{ qrCode ? 'cancel' : 'close' }}</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>             
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="success" :loading="loading" small @click.native="updateSetting(s)" v-if="user.role == 'master' || user.role == 'superadmin'">update</v-btn>
                      <v-btn color="primary" :loading="loading" small text @click.native="genToken(s)" v-if="user.role == 'master' || user.role == 'superadmin'">GEN TOKEN</v-btn>
                      <v-btn color="error" :loading="loading" small @click.native="clearQ(s)">clear q</v-btn>
                      <v-btn color="primary" :loading="loading" small text @click.native="startSession(s)">start</v-btn>
                      <v-btn color="primary" :loading="loading" small text @click.native="statusSession(s)">status</v-btn>
                      <v-btn color="primary" :loading="loading" small text @click.native="checkSessionStatus(s)">check status</v-btn>
                      <v-btn color="primary" :loading="loading" small text @click.native="qrSession(s)">QR</v-btn>
                      <v-btn color="primary" :loading="loading" small text @click.native="closeSession(s)" v-if="user.role == 'master' || user.role == 'superadmin'">close</v-btn>
                      <v-btn color="primary" :loading="loading" small text @click.native="logoutSession(s)" v-if="user.role == 'master' || user.role == 'superadmin'">logout</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = {'Accept': 'application/json'};
import { storageRef, firebase, db, auth, store } from '@/fb';


export default {
  components: { Search, Paging, multiDialog },
  data() {
    return {
      loading:false,
      dialog:false,
      vresource:[],
      resource:[],
      search:null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys:[

      ],
      resourceSettings:{
        resourceName:null,
        search:false,
        create:true,
        pagination:true,
      },
      newResource:{},
      editing:false,
      deleting:false,
      programs:[],
      countries:[],
      newDialog:false,
      settings:[],
      instances:[],
      qr:null,
      qrCode:null,
    }
  },
  
  methods: {
    getFormat(d){
      return format(d)
    },
    async clearQ(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        let r = await axios.get(`https://aramccocrm.com/api/api/v1/clear-queue/${s.country}`).then(x=>x.data)
        this.$emit('snackbarNotification', `Clear`, 'success')
        this.loading = false
      })
    },
    async genToken(s) {
      return new Promise (async (res, rej)=>{
        if(!s.id){
          s.id = getRandomInt(11111, 999999)
        }
        this.loading = true
        var config = {
          method: 'post',
          url: `${s.instance}/aramcco${s.id}/${s.secret}/generate-token`,
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r && r.token) {
          s.token = r.token
          await this.updateSetting(s)
          await this.loadSettings()
          this.loading = false
        }
        res(r)
      })
    },
    async startSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var data = JSON.stringify({
          "webhook": "https://webhook.site/4ecb49a5-11ab-4f33-83e6-958f4f4f2410",
          "waitQrCode": true
        });
        var config = {
          method: 'post',
          url: `${s.instance}/aramcco${s.id}/start-session`,
          headers: { 
            'Content-Type': 'application/json', 
            'Authorization': 'Bearer ' + s.token
          },
          data
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r && r.qrcode && r.status != "CONNECTED") {
          this.loading = false
          this.qr = true
          this.qrCode = !r.qrcode.includes('data:image') ? 'data:image/png;base64,' + r.qrcode : r.qrcode 
          this.checkInstance = s
        } else if(r.status == "CONNECTED") {
          this.loading = false
          this.$emit('snackbarNotification', `Authenticated`, 'success')
        } else {
          this.loading = false
          this.$emit('snackbarNotification', `Count to 20 and try again`, 'success')
        }
        res(r)
      })
    },
    async statusSession(s) {
      return new Promise (async (res, rej)=>{
        var config = {
          url: `${s.instance}/aramcco${s.id}/status-session`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r && r.qrcode) {
          this.loading = false
          this.qr = true
          this.qrCode = !r.qrcode.includes('data:image') ? 'data:image/png;base64,' + r.qrcode : r.qrcode 
          this.checkInstance = s
        } else if(r.status == "CONNECTED") {
          this.loading = false
          this.$emit('snackbarNotification', `Authenticated`, 'success')
        } else if(!r.qrcode && r.status == "CLOSED") {
          this.loading = false
          this.$emit('snackbarNotification', `Please click start first and wait for 20 seconds`, 'success')
        }
        res(r)
      })
    },
    async checkSessionStatus(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/aramcco${s.id}/check-connection-session`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r) {
          this.loading = false
          this.$emit('snackbarNotification', `STATUS: ${r.status} | ${r.message}`, 'success')
        }
        res(r)
      })
    },
    async qrSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/aramcco${s.id}/qrcode-session`,
          method: 'get',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r) {
          this.loading = false
          this.qr = true
          this.qrCode = r
          this.checkInstance = s
        }
        res(r)
      })
    },
    async closeSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/aramcco${s.id}/close-session`,
          method: 'post',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r.status) {
          this.$emit('snackbarNotification', `Browser Closed`, 'success')
          this.loading = false
        } else {
          this.$emit('snackbarNotification', `Failed closing`, 'success')
          this.loading = false
        }
        res(r)
      })
    },
    async logoutSession(s) {
      return new Promise (async (res, rej)=>{
        this.loading = true
        var config = {
          url: `${s.instance}/aramcco${s.id}/logout-session`,
          method: 'post',
          headers: { 
            'Authorization': 'Bearer ' + s.token
          }
        };
        const axios_new = axios.create();
        let r = await axios_new(config).then(x=>x.data)
        .catch((error)=> {
          this.loading = false
          console.log(error);
        });
        console.log(r)
        if(r.status) {
          this.$emit('snackbarNotification', `WA logged out`, 'success')
          this.loading = false
        } else {
          this.$emit('snackbarNotification', `Failed WA log out`, 'success')
          this.loading = false
        }
        res(r)
      })
    },
    async updateSetting(s) {
      return new Promise(async (res, rej)=>{
        this.loading = true
        await db.ref(`settings/newwa/numbers/${s.key}`).update(s)
        this.$emit('snackbarNotification', `Autosaved`, 'success')
        this.loading = false
        res(true)
      })
    },
    async storeSettings() {
      let s = {}
      for (let i = 0; i < this.settings.length; i++) {
        const set = this.settings[i];
        s[set.key] = set
      }
      await db.ref(`settings/newwa/numbers`).update(s)
      this.$emit('snackbarNotification', `Updated Settings`, 'success')
    },

    async checkStatus(s) {
      this.loading = true
      let a =  await this.$store.dispatch('postResource', {resource:'/instance-check', value:{url:`${s.instance}/status?token=${s.token}`}})

      console.log(a)
      if(a.qrCode) {
        this.qr = true
        this.qrCode = a.qrCode
        this.$emit('snackbarNotification', `Please scan ${s.number} QR code`, 'error')
      } else if(a.accountStatus == 'authenticated') {
        this.$emit('snackbarNotification', `${a.accountStatus}`, 'success')
        this.qr = false
        this.qrCode = null
      } else {
        this.$emit('snackbarNotification', `Please Click On Use WA Here`, 'success')
        this.qr = false
        this.qrCode = null
      }
      this.loading = false

    },
    async useHere(s){
      let setting = {
      }
      let a = await axios.post(`${s.instance}/takeover?token=${s.token}`, setting, {headers}).then(x=>x.data)
      console.log(a)
      this.$emit('snackbarNotification', `Whatsapp used here now`, 'success')
    },
    async setupInstance(s){
      this.loading = true
      let setting = {
        "webhookUrl": "https://aramcco-crm.uc.r.appspot.com/WAhook",
        "ackNotificationsOn": "true",
        "chatUpdateOn": "false",
        "videoUploadOn": "true",
        "guaranteedHooks": "true",
        "ignoreOldMessages": "false",
        "instanceStatuses": "true",
        "webhookStatuses": "true",
        "statusNotificationsOn": "false",
        "url": `${s.instance}/settings?token=${s.token}`,
      }
      let a =  await this.$store.dispatch('postResource', {resource:'/instance-setup', value:setting})
      console.log(a)
      if(a.error) {
        this.$emit('snackbarNotification', a.error, 'error')
      } else {
        this.$emit('snackbarNotification', `Updated Settings`, 'success')
      }
      this.loading = false
    },
    async setupProfile(s) {
      this.loading = true
      let setting = {
        "about": "Aramcco In Germany",
        "address": "Maybachstraße 50, 70469 Stuttgart, Germany",
        "description": "Aramcco In Germany \n\naramccogermany.com",
        "email": "info@aramccogermany.com",
        "vertical": "Education",
        "phone": "4971199788650",
        "photo": "https://firebasestorage.googleapis.com/v0/b/aramcco-crm.appspot.com/o/23376664_1344224552371547_7904548405331847609_n.png?alt=media&token=bac4699a-3ff8-488d-9410-1639264046bf",
        "url": `${s.instance}/me?token=${s.token}`,
      }
      let a =  await this.$store.dispatch('postResource', {resource:'/instance-setup', value:setting})
      if(a.error) {
        this.$emit('snackbarNotification', a.error, 'error')
      } else {
        this.$emit('snackbarNotification', `Updated Settings`, 'success')
      }
      this.loading = false
    },
    async setInstanceVars(i) {
      let str = this.instances.filter(x=>x.id == this.settings[i].id)[0].apiUrl
      this.settings[i].instance = str.substring(0, str.length - 1)
      this.settings[i].paidTill = this.instances.filter(x=>x.id == this.settings[i].id)[0].paidTill
      this.settings[i].stopped = this.instances.filter(x=>x.id == this.settings[i].id)[0].stopped
      this.updateSetting(this.settings[i])
    },
    async deleteInstance(s) {
      return new Promise(async (res, rej)=>{
        this.loading = true
        await db.ref(`settings/newwa/numbers`).update({[s.key]:null})
        await this.loadSettings()
        this.loading = false
        res()
      })
    },
    uid(){
      return randomString(10, '#Aa')
    },
    async addNumber(){
      return new Promise(async (res, rej) =>{
        this.loading = true
        let k = this.uid()
        await db.ref(`settings/newwa/numbers/${k}`).update({key:k})
        await this.loadSettings()
        this.loading = false
      })
    },
    async loadSettings(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        console.log(this.user)
        let a = await db.ref(`settings/newwa/numbers`).once('value').then(x=>x.val())
        let settings = a ? 
          Object.values(a)
          .map((x, i)=>{return{...x,key:Object.keys(a)[i]}})
          .sort( (a, b)=> a.country > b.country ? -1 : 1 )
          : []
        console.log(settings)
        console.log()
        let user_countries = this.user.countries.map(x=>x.slug)
        this.settings = settings.filter(x=>{
          if(this.user.role == 'master' || this.user.role == 'superadmin') {
            return x
          } else {
            if (user_countries.length && user_countries.includes(x.country)) {
              return x
            }
          }
        })

        res(true)
        this.loading = false
      })
    },
    async loadInstances(){
      return new Promise(async (res, rej)=>{
        this.instances = await this.$store.dispatch('getResource', {resource:'/instances'})
        res(true)
      })
    },
    async getLastMessage(convo){
      return new Promise(async (res, rej) =>{
        this.loading = true
        console.log(convo)
        let msgs = await store.collection("waconversations").doc(convo.key).collection('messages').get().then(x => x.docs.map(y => {
          return {
            ...y.data(),
            key: y.id
          }
        }));
        console.log(msgs)
        this.msgs = msgs.reverse()
        this.loading = false
        res(true)
      })
    },
    async load_log(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let a = await store.collection("waconversations")
        .limit(10).get().then(x => x.docs.map(y => {
          return {
            ...y.data(),
            key: y.id
          }
        }));
        console.log(a)
        this.last = a
        this.loading = false
        res(true)
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        this.loading = true
        let c = await this.$store.dispatch('getResource', {resource:'/countries'})
        let p = await this.$store.dispatch('getResource', {resource:'/programs'})
        this.countries = c.map(x=>{return {...x, text:x[this.language]}})
        this.programs = p.map(x=>{return {...x, text:x[this.language]}})
        await this.loadSettings()
        res(true)
        this.loading = false
      })
    }
  },
  watch:{
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
  async created(){
    await this.init()
  },
  
}
</script>

<style>
.adminSwitch .v-input {
  margin-top:0 !important;
}
.adminSwitch .v-input__control {
  margin-bottom:0 !important;
}
.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>